export default ({get}) => ({
    data(){
        return {
            rate_info: {}
        }
    },
    mounted(){
        this.getRateData()
    },
    methods:{
        async getRateData(){
            const data = await get()
            console.log(data);
            this.rate_info = data
        }
    }
})